export default __webpack_public_path__ + "static/media/i193jk.1af056d5.webp";